var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'mobile': _vm.isMobile, 'tablet': _vm.isTablet },attrs:{"id":"app"}},[(!_vm.isVisited)?_c('SitePreloader'):_vm._e(),(!_vm.isMobDevice)?_c('Pannels'):_c('PannelsMobile'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }